import { Component, OnInit } from '@angular/core';

import { distinctUntilChanged, map } from 'rxjs/operators';

import FilterChange from '@app/shared/filters/filter-change.model';
import SeasonFacade from '@app/core/facades/season.facade';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '211px';

@Component({
  selector: 'app-filter-season',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class SeasonFilter extends FilterComponent implements OnInit {
  public readonly label = 'Season';
  public width = SIZE;

  constructor(private readonly _data: SeasonFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateSeason(value);
    this.valueChange.emit(new FilterChange(FilterType.Season, value));
  }

  ngOnInit() {
    this.options$ = (!!this.config.transform ? this.config.transform(this._data.seasons$) : this._data.seasons$).pipe(
      distinctUntilChanged(),
      map((options: Array<{ [key: string]: string | number }>) =>
        options.map((option) => ({
          label: `${option.seasonName} ${option.seasonYear}`,
          value: `${option.seasonName} ${option.seasonYear}`,
        }))
      )
    );

    this.initDefaultValues(this._data.selected$);
  }
}
